var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [(
          _vm.params &&
          _vm.params.context &&
          _vm.params.context.parentComponent &&
          _vm.params.context.parentComponent.permissions &&
          _vm.params.context.parentComponent.permissions.change &&
          _vm.params.context.parentComponent.selectedDaDetails &&
          _vm.params.context.parentComponent.selectedDaDetails.status &&
          ['Ready For Invoice', 'Invoice Generated'].indexOf(
            _vm.params.context.parentComponent.selectedDaDetails.status
          ) == -1 &&
          _vm.params.context.parentComponent.selectedDaDetails.payment_term !=
            'Cash'
        )?_c('v-icon',_vm._g(_vm._b({staticClass:"ml-1 mr-2",attrs:{"color":"primary"},on:{"click":_vm.editItem}},'v-icon',attrs,false),on),[_vm._v(" mdi-pencil ")]):_vm._e()]}}])},[_c('span',[_vm._v("Edit")])]),_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [(
          _vm.params &&
          _vm.params.context &&
          _vm.params.context.parentComponent &&
          _vm.params.context.parentComponent.permissions &&
          _vm.params.context.parentComponent.permissions.delete &&
          _vm.params.context.parentComponent.selectedDaDetails &&
          _vm.params.context.parentComponent.selectedDaDetails.status &&
          ['Ready For Invoice', 'Invoice Generated'].indexOf(
            _vm.params.context.parentComponent.selectedDaDetails.status
          ) == -1 &&
          _vm.params.context.parentComponent.selectedDaDetails.payment_term !=
            'Cash'
        )?_c('v-icon',_vm._g(_vm._b({staticClass:"ml-2 mr-1",attrs:{"color":"primary"},on:{"click":_vm.deleteDeliveryCharge}},'v-icon',attrs,false),on),[_vm._v(" mdi-delete ")]):_vm._e()]}}])},[_c('span',[_vm._v("Delete")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }